<template>
    <DatePicker
        ref="dateSelector"
        v-model="line.date"
        size="sm"
        data-cy="trans-entry-date"
        date-format="dd.MM.yy"
        placeholder="Dato"
        :year-color-hint="false"
        @internal-enter="onEnterKey"
        @paste="onPaste"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import DatePicker from '@/dateUtils/DatePicker.vue'
import {usePasteHandler} from '@/csv-transaction-importer/createTransPasteHandler'
const onPaste = usePasteHandler()
const line = defineModel<TransactionEntryLine>({required: true})
const emit = defineEmits(['moveToNext'])

const onEnterKey = () => {
    emit('moveToNext')
}



</script>

<style scoped>

</style>